import { render, staticRenderFns } from "./fullpagehorsesmouth.vue?vue&type=template&id=81dd6b52&scoped=true"
import script from "./fullpagehorsesmouth.vue?vue&type=script&lang=js"
export * from "./fullpagehorsesmouth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dd6b52",
  null
  
)

export default component.exports